import './HStory.scss';

import * as tsx from 'vue-tsx-support';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { HStoryTop } from './HStoryTop';
import { HStoryItem } from './HStoryItem';
import { ResolvedLanugageData } from '~/server-middleware/data-server/adapter/ACCOAdapter/schemes';
import { AvailableLanguage, StoryModule } from '~/schemes';

export interface HStoryProps {
  value: ResolvedLanugageData<StoryModule['properties'], AvailableLanguage>;
}

export interface HStoryEmits {}

export interface HStoryScopedSlots {}

@Component<HStoryRef>({
  name: 'HStory',
  mounted() {
    window.addEventListener('scroll', this.scrollAnimation);
    this.scrollAnimation(); // 初回実行
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollAnimation);
  },
  render() {
    return (
      <div class="h-container h-stories">
        {this.value.stories.map((story, index) => (
          <div key={story.key}>
            {/* 一つ目のストーリーのみ異なるデザインなのでコンポーネントを分けています */}
            {index === 0 ? (
              <HStoryTop story={story} />
            ) : (
              <HStoryItem story={story} />
            )}
          </div>
        ))}
      </div>
    );
  },
})
export class HStoryRef extends Vue implements HStoryProps {
  @Prop({ type: Object, required: true })
  readonly value!: ResolvedLanugageData<
    StoryModule['properties'],
    AvailableLanguage
  >;

  /**
   * スクロール量に応じたアニメーションを実行
   */
  private scrollAnimation() {
    const stories = document.querySelectorAll('.h-story');
    stories.forEach((story) => {
      // すでにアニメーションが完了している場合はスキップ
      if (story.classList.contains('hasAnimated')) return;

      const storyPosition = story.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // ビューポート外ならスキップ
      if (storyPosition.top > windowHeight || storyPosition.bottom < 0) return;

      // アニメーション範囲の設定
      const animationStartPoint = windowHeight * 0.85; // 画面上側から85%の位置でアニメーション開始
      const animationEndPoint = windowHeight * 0.45; // 画面上側から45%の位置でアニメーション終了
      const animationProgress = // アニメーションの進捗度合いを算出（マイナスや1以上になり得る）
        (storyPosition.top - animationStartPoint) /
        (animationEndPoint - animationStartPoint);

      // 進捗度合いを0～1の範囲で表現
      const constrainedProgress = Math.min(Math.max(animationProgress, 0), 1);

      // スクロール量に比例してスタイルを更新
      const horizontalInset = 50 - constrainedProgress * 50;
      const verticalInset = 50 - constrainedProgress * 50;
      // ストーリーの左上または右上にカードが表示されるよう-5%の余白を設定
      (story as HTMLElement).style.clipPath = `inset(${verticalInset - 5}% ${
        horizontalInset - 5
      }% ${verticalInset - 5}% ${horizontalInset - 5}%)`;
      (story as HTMLElement).style.opacity = String(constrainedProgress);

      // アニメーションが完了したらそれを示すclassを付与
      if (constrainedProgress === 1) {
        story.classList.add('hasAnimated');
      }
    });
  }
}

export const HStory = tsx
  .ofType<HStoryProps, HStoryEmits, HStoryScopedSlots>()
  .convert(HStoryRef);
